import Vue from 'vue';
import ContactListCellRendererCategories
  from '@/views/modules/contacts/cell-renderers/ContactListCellRendererCategories.vue';

/**
 * status floating filter
 *
 * @module views/modules/components/filters/agGridStatusFloatingFilter
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-data {Array.<Object>} status - filter selected status
 * @vue-event {void} remove - remove al status of filter
 * @vue-event {void} onParentModelChanged - called on filter changed
 */
export default Vue.extend({
  name: 'agGridStatusFloatingFilter',
  template: `
    <div class="flex w-full justify-center items-center">
    <span>{{ statusName | truncateEllipsis(100)  }}</span>

    <vx-tooltip
      v-if="status"
      color="danger"
      :text="$t('$General.Reset')"
      class="inline-block" >
      <vs-button
        radius
        color="danger"
        size="small"
        type="flat"
        icon-pack="feather"
        icon="icon-x"
        class="ml-1"
        @click="reset"></vs-button>
    </vx-tooltip>
    </div>
    `,
  components: {
    ContactListCellRendererCategories,
  },
  data() {
    return {
      status: '',
    };
  },
  computed: {
    statusName() {
      return this.params
      && this.params.filterParams
      && this.params.filterParams.i18nPrefixStatus
      && this.status
        ? this.$t(`${this.params.filterParams.i18nPrefixStatus}${this.status}`)
        : this.status;
    },
  },
  methods: {
    reset() {
      // Explicitly set status to empty string to ensure reactivity
      this.$set(this, 'status', '');

      this.params.parentFilterInstance((instance) => {
        instance.setModel(null);
      });
    },
    onParentModelChanged(parentModel) {
      if (parentModel) {
        this.$set(this, 'status', parentModel.filter);
      } else {
        this.$set(this, 'status', '');
      }
    },
  },
});
